import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { BRAND } from '../../constants/branding';

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="h6" fontWeight={700} gutterBottom sx={{ color: BRAND.colors.text }}>
      {title}
    </Typography>
    <Typography variant="body2" component="div" sx={{ color: BRAND.colors.textDim, lineHeight: 1.9 }}>
      {children}
    </Typography>
  </Box>
);

export const TermsPage: React.FC = () => (
  <Container maxWidth="md" sx={{ py: { xs: 6, md: 8 } }}>
    <Typography variant="overline" sx={{ color: BRAND.colors.primary, fontWeight: 700 }}>
      Legal
    </Typography>
    <Typography variant="h3" fontWeight={800} sx={{ mt: 1, mb: 1 }}>
      Terms &amp; Conditions
    </Typography>
    <Typography variant="body2" sx={{ mb: 4, color: BRAND.colors.textDim }}>
      Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
    </Typography>

    <Section title="1. Acceptance of terms">
      By accessing or using {BRAND.name} at {BRAND.domain}, you agree to these Terms &amp; Conditions.
      If you do not agree, please do not use the service.
    </Section>

    <Section title="2. Service description">
      {BRAND.name} provides AI-assisted social media content creation, scheduling, analytics, and
      multi-platform publishing tools. Features may change as we improve the product.
    </Section>

    <Section title="3. Account responsibilities">
      You are responsible for maintaining the security of your account and all activity under your credentials.
      You must be at least 18 years old to use the service.
    </Section>

    <Section title="4. Acceptable use">
      You agree not to use {BRAND.name} to publish unlawful, harmful, misleading, or infringing content.
      You must comply with the terms and policies of each connected social platform.
    </Section>

    <Section title="5. AI-generated content">
      Content generated by AI is provided as a starting point. You are solely responsible for reviewing,
      editing, and approving content before publication.
    </Section>

    <Section title="6. Third-party integrations">
      Connecting social accounts requires authorization via each platform&apos;s OAuth flow.
      We are not responsible for changes to third-party APIs, rate limits, or platform policies.
    </Section>

    <Section title="7. Limitation of liability">
      {BRAND.name} is provided &quot;as is&quot; without warranties of any kind. To the fullest extent
      permitted by law, we are not liable for indirect, incidental, or consequential damages.
    </Section>

    <Section title="8. Termination">
      We may suspend or terminate accounts that violate these terms. You may stop using the service at any time.
    </Section>

    <Section title="9. Contact">
      Questions about these terms? Email{' '}
      <a href={`mailto:${BRAND.supportEmail}`} style={{ color: BRAND.colors.primary }}>
        {BRAND.supportEmail}
      </a>.
    </Section>
  </Container>
);

export default TermsPage;
